import React, { useMemo, useState } from 'react';
import { Search, Users, Layers, FileText, Wallet, Download, X, MoreVertical, ExternalLink } from 'lucide-react';
import { AppBadge } from '../components/base/AppBadge';
// Mock Data
const MOCK_SUPPLIERS = [{
  id: '1',
  name: 'TechCorp Solutions',
  email: 'admin@techcorp.it',
  type: 'Sviluppo',
  servicesCount: 4,
  contractStatus: 'Attivo',
  monthlySpend: 4500
}, {
  id: '2',
  name: 'CloudSys Italia',
  email: 'billing@cloudsys.it',
  type: 'Cloud',
  servicesCount: 8,
  contractStatus: 'In rinnovo',
  monthlySpend: 8200
}, {
  id: '3',
  name: 'SecurIT Partners',
  email: 'info@securit.com',
  type: 'Sicurezza',
  servicesCount: 2,
  contractStatus: 'Attivo',
  monthlySpend: 2100
}, {
  id: '4',
  name: 'DataConsulting SPA',
  email: 'contact@dataconsulting.it',
  type: 'Consulenza',
  servicesCount: 5,
  contractStatus: 'Scaduto',
  monthlySpend: 0
}, {
  id: '5',
  name: 'InfraNet Group',
  email: 'support@infranet.it',
  type: 'Infrastruttura',
  servicesCount: 4,
  contractStatus: 'Attivo',
  monthlySpend: 3650
}];
export function FornitoriPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedType, setSelectedType] = useState('Tutti');
  // Filter logic
  const filteredSuppliers = useMemo(() => {
    return MOCK_SUPPLIERS.filter(supplier => {
      if (searchQuery && !supplier.name.toLowerCase().includes(searchQuery.toLowerCase()) && !supplier.email.toLowerCase().includes(searchQuery.toLowerCase())) {
        return false;
      }
      if (selectedType !== 'Tutti' && supplier.type !== selectedType) {
        return false;
      }
      return true;
    });
  }, [searchQuery, selectedType]);
  const handleResetFilters = () => {
    setSearchQuery('');
    setSelectedType('Tutti');
  };
  const getTypeBadgeVariant = (type: string) => {
    switch (type) {
      case 'Sviluppo':
        return 'blue';
      case 'Cloud':
        return 'primary';
      case 'Sicurezza':
        return 'red';
      case 'Consulenza':
        return 'amber';
      case 'Infrastruttura':
        return 'default';
      default:
        return 'default';
    }
  };
  const getContractBadgeVariant = (status: string) => {
    switch (status) {
      case 'Attivo':
        return 'success';
      case 'In rinnovo':
        return 'warning';
      case 'Scaduto':
        return 'danger';
      default:
        return 'default';
    }
  };
  return <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8" data-id="element-2593" data-mp="1uokfjhnvswhg">
      {/* Header Section */}
      <div className="mb-8" data-id="element-2594" data-mp="1youkcqzxtguq">
        <h1 className="text-[28px] md:text-[32px] font-semibold text-[#2a3a54] tracking-tight" data-id="element-2595" data-mp="23n5tt0mblpcf">
          Fornitori
        </h1>
      </div>

      {/* KPI Cards Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-2596" data-mp="4buzojgp9wgl">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-2597" data-mp="99whz26axrr0">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-2598" data-mp="1qdr69qtgu7v">
            Totale Fornitori
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-2599" data-mp="3t2yomrd7w8pt">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-2600" data-mp="3o4f2oqymiwxg">14</span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-2601" data-mp="3j7534ihit4vw">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-2602" data-mp="kopzxudtg22x">
            Servizi Esternalizzati
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-2603" data-mp="fpwnm5a9mh4c">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-2604" data-mp="apr276ul9qup">23</span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-2605" data-mp="6pgmh2gzvm2n">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-2606" data-mp="2vh12mjzmpl94">
            Contratti Attivi
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-2607" data-mp="2rduv790s5o12">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-2608" data-mp="j67v4mh055g6">11</span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-2609" data-mp="nwocuiruvd8c">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-2610" data-mp="98bnw5r6qunc">
            Spesa Mensile
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-2611" data-mp="e6lm6p87ibd6">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-2612" data-mp="e520gj3s7840">
              €18.450
            </span>
          </div>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm flex flex-col md:flex-row gap-4 items-center justify-between mb-6" data-id="element-2613" data-mp="16vaepzv758db">
        <div className="flex flex-1 items-center gap-4 w-full md:w-auto" data-id="element-2614" data-mp="wxcppa5ij7jn">
          <div className="relative flex-1 md:max-w-xs" data-id="element-2615" data-mp="wzpea65s0g5o">
            <Search className="w-4 h-4 text-gray-400 absolute left-3 top-3" data-id="element-2616" data-mp="3dl722fcju9wz" />
            <input type="text" placeholder="Cerca fornitore..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-gray-50 border border-gray-200 text-[#1A202C] pl-9 pr-4 py-2.5 rounded-lg text-[13px] placeholder-gray-400 focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8]" data-id="element-2617" data-mp="3hod9hqbee751" />
          </div>

          <select value={selectedType} onChange={e => setSelectedType(e.target.value)} className="bg-gray-50 border border-gray-200 text-[#1A202C] px-4 py-2.5 rounded-lg text-[13px] focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8]" data-id="element-2618" data-mp="3f3yp5grgct8j">
            <option value="Tutti" data-id="element-2619" data-mp="314z2geni2of0">Tutti i tipi</option>
            <option value="Consulenza" data-id="element-2620" data-mp="2wco1d8h0wwkv">Consulenza</option>
            <option value="Sviluppo" data-id="element-2621" data-mp="2wb36tiupldn0">Sviluppo</option>
            <option value="Infrastruttura" data-id="element-2622" data-mp="28mbnlgz3k5md">Infrastruttura</option>
            <option value="Cloud" data-id="element-2623" data-mp="23oifgie8h1jg">Cloud</option>
            <option value="Sicurezza" data-id="element-2624" data-mp="23nqvk4u00s90">Sicurezza</option>
          </select>
        </div>

        <div className="flex gap-2" data-id="element-2625" data-mp="2tbmjxbfcvvfi">
          <button title="Export CSV" className="p-2 text-gray-600 hover:text-[#1A202C] hover:bg-gray-100 rounded-lg transition-all" data-id="element-2626" data-mp="2tal8h5ufh6x9">
            <Download className="w-4 h-4" data-id="element-2627" data-mp="3259cyts6ikl0" />
          </button>
          <button onClick={handleResetFilters} title="Reset Filters" className="p-2 text-gray-600 hover:text-[#1A202C] hover:bg-gray-100 rounded-lg transition-all" data-id="element-2628" data-mp="374c7hkaj98eq">
            <X className="w-4 h-4" data-id="element-2629" data-mp="2eedfph4yex6d" />
          </button>
        </div>
      </div>

      {/* Suppliers Table */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2630" data-mp="2jd6v5f3swy96">
        <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between" data-id="element-2631" data-mp="2oecl5562u7f0">
          <h2 className="text-[16px] font-semibold text-[#2a3a54]" data-id="element-2632" data-mp="3usbwaeoaaoqo">
            Elenco Fornitori
          </h2>
          <button className="text-[13px] text-gray-500 font-medium hover:text-[#2a3a54] transition-colors" data-id="element-2633" data-mp="3lsnt65x7avj">
            Esporta Report
          </button>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-2634" data-mp="1j7csgfv9eddx">
          <table className="w-full" data-id="element-2635" data-mp="1ef1rd9os8ljs">
            <thead className="bg-gray-50/50 border-b border-gray-100" data-id="element-2636" data-mp="1ee0gp6boi12l">
              <tr data-id="element-2637" data-mp="19grxr3ipht0a">
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2638" data-mp="19f737dwe6a2f">
                  Fornitore
                </th>
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2639" data-mp="10ftq8b9273cy">
                  Tipo
                </th>
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2640" data-mp="vgph1km4x5mm">
                  Servizi
                </th>
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2641" data-mp="2ptfbc3gf0guj">
                  Spesa Mensile
                </th>
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2642" data-mp="1tqb8grbrv1mf">
                  Contratto
                </th>
                <th className="px-6 py-3 text-right text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2643" data-mp="1yr8mqstnvbin">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-2644" data-mp="1ox88o1geivxs">
              {filteredSuppliers.map(supplier => <tr key={supplier.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-2645" data-mp="1b1wdjsyc33gc">
                  <td className="px-6 py-4" data-id="element-2646" data-mp="11zx01amj2hi5">
                    <div data-id="element-2647" data-mp="12182960brh75">
                      <p className="text-[13px] font-medium text-[#2a3a54]" data-id="element-2648" data-mp="16076spi59by2">
                        {supplier.name}
                      </p>
                      <p className="text-[13px] text-gray-500" data-id="element-2649" data-mp="2wdee8711m20i">
                        {supplier.email}
                      </p>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-2650" data-mp="os66mrgbcyzo">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium border ${supplier.type === 'Sviluppo' ? 'bg-blue-50 text-blue-700 border-blue-100' : supplier.type === 'Cloud' ? 'bg-indigo-50 text-indigo-700 border-indigo-100' : supplier.type === 'Sicurezza' ? 'bg-red-50 text-red-700 border-red-100' : supplier.type === 'Consulenza' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-gray-50 text-gray-700 border-gray-100'}`} data-id="element-2651" data-mp="op1rx0582kur">
                      {supplier.type}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2652" data-mp="1hdfttqzfm1bl">
                    <span className="text-[13px] text-gray-500" data-id="element-2653" data-mp="1chs6lh4ifi8q">
                      {supplier.servicesCount}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2654" data-mp="3e83mexsmn342">
                    <span className="text-[13px] text-gray-500" data-id="element-2655" data-mp="3e9dkvo3e6db8">
                      €{supplier.monthlySpend.toLocaleString()}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2656" data-mp="26nafxcewbs5z">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium border ${supplier.contractStatus === 'Attivo' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : supplier.contractStatus === 'In rinnovo' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`} data-id="element-2657" data-mp="26m8v4g82vrb2">
                      {supplier.contractStatus}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-2658" data-mp="2lj9ik7j8l03q">
                    <button className="text-[13px] font-medium text-[#00B4D8] hover:text-[#0096b4] transition-colors" data-id="element-2659" data-mp="2gm9gs8tf6jif">
                      Dettagli
                    </button>
                  </td>
                </tr>)}
              {filteredSuppliers.length === 0 && <tr data-id="element-2660" data-mp="3glth85xw3wf5">
                  <td colSpan={6} className="px-6 py-8 text-center text-gray-500 text-[13px]" data-id="element-2661" data-mp="3gmlb9cbu9m3b">
                    Nessun fornitore trovato con i filtri correnti.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden flex flex-col divide-y divide-gray-100" data-id="element-2662" data-mp="3f1fcd3pqwnz">
          {filteredSuppliers.map(supplier => <div key={supplier.id} className="p-4 flex flex-col gap-3" data-id="element-2663" data-mp="8dl56olfgslm">
              <div className="flex justify-between items-start" data-id="element-2664" data-mp="d4upras4d5qn">
                <div data-id="element-2665" data-mp="d5mmwq1d7bj1">
                  <p className="text-[13px] font-medium text-[#2a3a54]" data-id="element-2666" data-mp="d776xlq1zc2n">
                    {supplier.name}
                  </p>
                  <p className="text-[12px] text-gray-500" data-id="element-2667" data-mp="m617toaf2om0">
                    {supplier.type} • {supplier.servicesCount} servizi
                  </p>
                </div>
                <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-medium border ${supplier.contractStatus === 'Attivo' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : supplier.contractStatus === 'In rinnovo' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`} data-id="element-2668" data-mp="2n7qoy9f5k668">
                  {supplier.contractStatus}
                </span>
              </div>
              <div className="flex justify-between items-center mt-1" data-id="element-2669" data-mp="36u6nc4r6lmf5">
                <span className="text-[13px] font-semibold text-[#1A202C]" data-id="element-2670" data-mp="31vlj7u8t6ilf">
                  €{supplier.monthlySpend.toLocaleString()}/mese
                </span>
                <button className="text-[12px] font-medium text-[#00B4D8]" data-id="element-2671" data-mp="3axbjlpko4rvc">
                  Dettagli
                </button>
              </div>
            </div>)}
          {filteredSuppliers.length === 0 && <div className="p-8 text-center text-gray-500 text-[13px]" data-id="element-2672" data-mp="1gk3n7th1o87l">
              Nessun fornitore trovato con i filtri correnti.
            </div>}
        </div>
      </div>
    </div>;
}